import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    help: { height: '100vh', display: 'flex', overflowX: 'hidden' },
    sidenav: {
      width: 320,
      backgroundColor: '#fc0',
      paddingBottom: 20,
    },
    content: {
      position: 'relative',
      flex: 1,
      marginRight: 2,
      padding: '4rem 5rem',
      boxShadow: '0 16px 32px 0 rgba(0,0,0,.12)',
      overflowY: 'auto',
      overflowX: 'hidden',
      '&::-webkit-scrollbar': {
        width: 6,
        height: 6,
      },

      '&::-webkit-scrollbar-track': {
        background: '#fff',
      },

      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.45)',
        borderRadius: 4,
      },

      '&::-webkit-scrollbar-corner': {
        background: '#fff',
      },
    },
    sidenav__menu: {
      height: 'calc(100vh - 130px)',
      overflow: 'hidden',
      overflowY: 'scroll',
      marginRight: 10,
      '&::-webkit-scrollbar': {
        width: 4,
        height: 4,
      },

      '&::-webkit-scrollbar-track': {
        background: '#fc0',
      },

      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.45)',
        borderRadius: 2,
      },

      '&::-webkit-scrollbar-corner': {
        background: '#fc0',
      },
    },
    sidenav__link: {
      position: 'relative',
      display: 'inline-block',
      fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
      fontSize: 15,
      lineHeight: 1.14,
      color: '#000',
      border: 0,
      background: 'transparent',
      outline: 'none',
      transition: 'all 0.1s linear',
      padding: '0 0 0 24px',
      textAlign: 'left',
      '&:before': {
        content: '"\u2014"',
        position: 'absolute',
        top: '50%',
        left: 0,
        color: '#000',
        transform: 'translateY(-50%)',
      },
      '&:hover': {
        color: '#fff',
        '&:before': {
          color: '#fff',
        },
      },
    },
    sidenav__link_active: {
      fontWeight: 'bold',
      color: '#ffffff',
      '&:before': {
        color: '#fff',
      },
    },
    accordionList: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
    },
    accordionItemIcon: {
      width: '1.2rem',
      height: '1.2rem',
      transition: 'transform 0.2s linear',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundImage:
        'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAABGklEQVR4Ae3RAcZCQRiF4buDfwshBGi+2UQgcIGAVtpSIuS/KyilG+UTcbk6zIH3GQBm3mM6AAAAAAAAAACA+eqf/yZBXcV/2XeCVPYx1FXj/FjGUMd45AQp/1HHGGLZNL+e61jHnKDmv8652YT1IvPfE2LX/Sh27/ycsF60yT/lk58JYn6eU4MJccjnlAmZ/33i0OAH4jg9Qcw/5g9YJpS+m6n0xvzpCfVe+nn59S7kGyYo+YYJWz3fO+E2PaFs9XzPhMy/6fmWCXq+YUJs9HzrhLh+JsQmrnq+bYKeb52g53snXPR88wQ93z9Bz/dP0PP9E/R89wQ93zpBz7dO0POtE/R86wQ93zpBzzdP+MoHAAAAAAAAAADAExTnTW20AtjhAAAAAElFTkSuQmCC)',
    },
    accordionItemInner: {
      maxHeight: 0,
      overflow: 'hidden',
      zIndex: 1,
      position: 'relative',
      transition: 'max-height 0.2s linear',
    },
    accordionItemContent: {
      padding: '0 20px 10px 30px',
    },
    accordionItemParagraph: {
      margin: 0,
      fontSize: '1rem',
      color: '#333',
      fontWeight: 300,
      lineHeight: 1.3,
    },
    accordionItemLine: {
      display: 'block',
      padding: '0.8rem 1.2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      zIndex: 2,
      position: 'relative',
      cursor: 'pointer',
    },
    accordionItemTitle: {
      fontSize: '1rem',
      margin: 0,
      fontWeight: 700,
      color: '#121212',
    },
    accordionItemOpened: {
      '& $accordionItemIcon': {
        transform: 'rotate(180deg)',
      },
      '& $accordionItemInner': {
        maxHeight: '100%',
        transition: 'max-height 0.2s linear',
      },
    },
  }
})
